module.exports = __webpack_public_path__ + "img/6.6f02b7c5.jpg";